/**
 * Format a date value to the standard display format: M/D/YYYY H:MM:SS AM/PM
 * Displays in the user's local timezone
 * 
 * @param value - Date object, ISO string, or timestamp
 * @returns Formatted date string or empty string if invalid
 */
export function formatDate(value: Date | string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }

  try {
    const date = value instanceof Date ? value : new Date(value);
    
    if (isNaN(date.getTime())) {
      return '';
    }

    return date.toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  } catch {
    return '';
  }
}

/**
 * Format a date value to just the date portion: M/D/YYYY
 * Displays in the user's local timezone
 * 
 * @param value - Date object, ISO string, or timestamp
 * @returns Formatted date string or empty string if invalid
 */
export function formatDateOnly(value: Date | string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }

  try {
    const date = value instanceof Date ? value : new Date(value);
    
    if (isNaN(date.getTime())) {
      return '';
    }

    return date.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return '';
  }
}
